



















































































































































































































































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import CompanyService from "@/services/CompanyService";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import CompanyDetailsDTO from "@/dto/company/CompanyDetailsDTO";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import { MelioStatus } from "@/dto/company/MelioStatus";
import UpdateCompanyDetailsRequest from "@/dto/company/UpdateCompanyDetailsRequest";
import FileUpload from "@/components/common/FileUpload.vue";
import {documentAccept} from "@/constants/FileConstants";
import PhoneInput from "@/components/util/PhoneInput.vue";
import UserDTO from "@/dto/UserDTO";
import NAICS_DICT from "@/data/NaicsDict.json";
import NaicsType from "@/dto/NaicsType";
import Workspaces from "@/state/Workspaces";
import AutoComplete from "@/components/common/AutoComplete.vue";
import AutoCompleteDTO from "@/components/common/AutoCompleteDTO";
import RegexUtils from "@/utils/RegexUtils";
import PortalInput from "@/components/common/PortalInput.vue";
import {ifValid} from "@/utils/ComponentUtils";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import {InputType} from "@/components/common/InputType";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption, {OptionsBuilder} from "@/components/common/SelectOption";
import {FederalTaxClassification} from "@/constants/FederalTaxClassification";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import RouteNames from "@/router/RouteNames";
import ReserveAgreementCreationModal from "@/components/profile/company/ReserveAgreementCreationModal.vue";
import PersonSearch from "@/components/common/PersonSearch.vue";
import PersonDTO from "@/dto/person/PersonDTO";
import {Md5} from "ts-md5";
import PortalDate from "@/components/common/PortalDate.vue";
import HistorySlider from "@/components/history/HistorySlider.vue";
import Notifications from "@/state/Notifications";
import History from "@/components/history/History.vue";
import {HistoryDomen} from "@/components/history/dto/HistoryDomen";
import ChangeActions from "@/components/history/dto/ChangeActions";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component({
	methods: {
		RouteNames() {
			return RouteNames
		},
		hashCode(obj: any): string {
			return Md5.hashStr(JSON.stringify(obj))
		},
	},
	computed: {
		ChangeActions() {
			return ChangeActions
		},
		HistoryDomen() {
			return HistoryDomen
		},
		SelectOption() {
			return SelectOption
		},
		InputType() {
			return InputType
		},
		naics(): Array<NaicsType> {
			return NAICS_DICT;
		},
		AutoCompleteDTO() {
			return AutoCompleteDTO
		}
	},
    components: {
	    History,
		HistorySlider,
		PortalDate,
	    PersonSearch,
		BTPortalCollapse,
		PortalSelect,
		SingleFileHolder,
		PortalInput,
		AutoComplete,
        PhoneInput,
        FileUpload
    }
})
export default class CompanyDetails extends Vue {
    private accept = documentAccept
    private insertNaicsType: string | null = null;
    private naicsTypes: Array<NaicsType> = NAICS_DICT;

	payload = new UpdateCompanyDetailsRequest();

    private company: CompanyDetailsDTO | null = null;

    private cerOfIncMeta: FileMetaDTO | null = null;

    private fillingReceiptMeta: FileMetaDTO | null = null;

    private ss4FormMeta: FileMetaDTO | null = null;

    private isDataReady = false;

	@Auth.Getter("hasAdministrativePrivileges")
	private hasAdministrativePrivileges!: boolean;

	private isUserSublimeEmployee: boolean = Workspaces.isUserSublimeEmployee;

    @AppModule.State
    private isMobile!: boolean;

    @AppModule.Action
    private startLoading!: () => void;

    @AppModule.Action
    private stopLoading!: () => void;

    @Auth.State
    private user!: UserDTO

    private message = "";

    private successful = false;

    private basicHistory = false;
	private taxHistory = false;
	private servicesHistory = false;

    get hashCode() {
        return (obj: any): string => Md5.hashStr(JSON.stringify(obj))
    }

    get naics(): Array<NaicsType> {
        return NAICS_DICT;
    }

    get SelectOption() {
        return SelectOption;
    }

	private buildClassificationOptions(): Array<SelectOption> {
		return [
			SelectOption.builder().title("Single member LLC").value(FederalTaxClassification.SOLE).build(),
			SelectOption.builder().title("C Corporation").value(FederalTaxClassification.C_CORP).build(),
			SelectOption.builder().title("S Corporation").value(FederalTaxClassification.S_CORP).build(),
			SelectOption.builder().title("Partnership").value(FederalTaxClassification.PARTNERSHIP).build(),
			SelectOption.builder().title("Trust/estate").value(FederalTaxClassification.TRUST_ESTATE).build(),
			SelectOption.builder().title("Limited liability company").value(FederalTaxClassification.LLC).build(),
			SelectOption.builder().title("Other").value(FederalTaxClassification.OTHER).build()
		];
	}

	private buildMelioStatusOptions(): Array<SelectOption> {
    return OptionsBuilder
        .of("Bank Activated", MelioStatus.BANK_ACTIVATED)
        .of("Bank Not Activated", MelioStatus.BANK_NOT_ACTIVATED)
        .of("Credit card", MelioStatus.CREDIT_CARD)
        .get();
	}

    mounted() {
		this.startLoading();
        Promise.all([this.loadCompanyDetails()]).then(
			res => {
				this.successful = true;
				this.message = "";
				this.stopLoading();
			},
			err => this.errorHandle(err)
		)
    }

    private errorHandle(error: any) {
        this.successful = false;
        const param = error?.response?.data?.param ? { param: error?.response?.data?.param } : {}
        this.message = this.$t(ErrorLocalePathUtils.getPathForError(error), param) as string;
        this.stopLoading();
    }

    private loadCompanyDetails(): Promise<void> {
        this.message = "";
        this.successful = false;
        this.startLoading();
        return CompanyService.getDetailsById(Workspaces.getCurrent.id).then(
            res => {
                this.isDataReady = true;
                this.mapCompanyDTOToPayload(res.data);
                this.successful = true;
                this.stopLoading();
            },
            err => {
                this.errorHandle(err)
            }
        )
    }

    private mapCompanyDTOToPayload(resCompany: CompanyDetailsDTO) {
        this.company = resCompany;
        this.payload.name = resCompany.name;
        this.payload.ein = resCompany.ein;
        this.payload.einVerificationProof = resCompany.einVerificationProof;
        this.payload.einVerificationDate = resCompany.einVerificationDate;
        this.payload.dba = resCompany.dba;
        this.payload.website = resCompany.website;
        this.payload.federalTaxClass = resCompany.federalTaxClass;
        this.payload.phone = resCompany.phone;
        this.payload.naicsCode = resCompany.naicsCode;
        this.payload.nationalTin = resCompany.nationalTin;
        this.payload.officer = resCompany.officer;
        this.payload.melioLink = resCompany.melioLink;
        this.payload.melioStatus = resCompany.melioStatus;
        this.payload.booksProLink = resCompany.booksProLink;
        this.payload.bsoId = resCompany.bsoId;
    }
	successHandle() {
        this.loadCompanyDetails();
        this.stopLoading();
        this.successful = true;
        this.message = this.$t("util.success.company_details") as string;
    }

    private saveBasicInfo() {
        this.message = "";
        ifValid(this, () => {
            this.startLoading();
            this.payload.companyId = Workspaces.getCurrent.id;
            CompanyService.updateCompanyDetails(this.payload).then(
                () => {
                    this.successHandle();
                    Notifications.success("Basic information updated successfully!");
                },
                (error) => {
                    this.errorHandle(error)
                }
            ).then(() => this.stopLoading());
        })
    }

    private saveTaxInfo() {
        this.message = "";
        ifValid(this, () => {
            this.startLoading();
            this.payload.companyId = Workspaces.getCurrent.id;
            CompanyService.updateCompanyDetails(this.payload).then(
                () => {
                    this.successHandle();
                    Notifications.success("Tax information updated successfully!");
                },
                (error) => {
                    this.errorHandle(error)
                }
            ).then(() => this.stopLoading());
        })
    }

    private saveServicesInfo() {
        this.message = "";
        ifValid(this, () => {
            this.startLoading();
            this.payload.companyId = Workspaces.getCurrent.id;
            CompanyService.updateCompanyDetails(this.payload).then(
                () => {
                    this.successHandle();
                    Notifications.success("External services updated successfully!");
                },
                (error) => {
                    this.errorHandle(error)
                }
            ).then(() => this.stopLoading());
        })
    }

    handleHeight() {
        return (this.isMobile ? '100' : '300') + 'px';
    }

    handleLabelForCerOfInf() : string {
        return (!this.cerOfIncMeta ? "Upload " : "Change ") + "certificate of incorporation";
    }

    handleLabelForFillReceipt() : string {
        return (!this.fillingReceiptMeta ? "Upload " : "Change ") + "filling receipt";
    }

	selectOfficer(person: PersonDTO | null) {
		console.log(person);
		this.payload.officer = person
	}

	private requestReserveAgreement(): void {
		this.$modal.show(
			ReserveAgreementCreationModal,
			{
				company: this.company,
				onSuccess: () => this.loadCompanyDetails()
			}
		)
	}

}
